import React from "react";
import "./App.css";

import DashBoard from "./Containers/DashBoard/DashBoard";
function App() {
  return (
    <div className="App">
      <DashBoard></DashBoard>
    </div>
  );
}

export default App;
